module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-17.59ca1f26.png";